import { Tooltip, Button, Tabs, Card, Row, Col, Tag } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";

function SingleUser() {
  const proHeight = document.body.clientHeight;

  const left = (
    <>
      <div className="pri-font text-lg">User</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <Card style={{ borderColor: "#e5e7eb", marginBottom: "24px" }}>
            <Row>
              <Col span={6} className="mb-6">
                <div className="text-xs">Username</div>
                <div>john</div>
              </Col>
              <Col span={6} className="mb-6">
                <div className="text-xs">First name</div>
                <div>John</div>
              </Col>
              <Col span={6} className="mb-6">
                <div className="text-xs">Last name</div>
                <div>Doe</div>
              </Col>
              <Col span={6} className="mb-6">
                <div className="text-xs">Unit head</div>
                <div>John Doe</div>
              </Col>
              <Col span={6}>
                <div className="text-xs">Unit name</div>
                <div>Kingsbury</div>
              </Col>
              <Col span={6}>
                <div className="text-xs">Level</div>
                <Tag color={"red"}>COMPANY</Tag>
              </Col>
              <Col span={6}>
                <div className="text-xs">Head unit</div>
                <div>Hayleys group</div>
              </Col>
              <Col span={6}>
                <div className="text-xs">Unit head</div>
                <div>John Doe</div>
              </Col>
            </Row>
          </Card>
        </div>
      </Content>
    </>
  );
}

export default SingleUser;
